/**
 * @fileoverview Helper functions for Informe OP validations
 */

/**
 * Valida que el rango de fechas sea válido (máximo 60 días)
 * @param {Date|string|null} startDate - Fecha de inicio
 * @param {Date|string|null} endDate - Fecha de fin
 * @returns {string|null} Mensaje de error si hay problema, null si es válido
 */
export function validateDateRange(startDate, endDate) {
  // Si alguna fecha es null, no validar (filtro opcional)
  if (!startDate || !endDate) {
    return null;
  }

  // Convertir a Date si es string
  const start = startDate instanceof Date ? startDate : new Date(startDate);
  const end = endDate instanceof Date ? endDate : new Date(endDate);

  // Validar que las fechas sean válidas
  if (isNaN(start.getTime()) || isNaN(end.getTime())) {
    return null; // Si las fechas no son válidas, dejar que el componente maneje el error
  }

  // Validar que la fecha de fin sea posterior o igual a la fecha de inicio
  if (end < start) {
    return 'La fecha de fin debe ser posterior a la fecha de inicio.';
  }

  // Calcular diferencia en días
  const diffTime = end.getTime() - start.getTime();
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

  // Validar que no exceda 60 días (2 meses)
  if (diffDays > 60) {
    return 'El rango de fechas no puede exceder 2 meses (60 días).';
  }

  return null; // Rango válido
}

/**
 * Verifica si hay al menos un filtro activo
 * @param {Object} filters - Objeto con los filtros
 * @param {Object} filters.estados - Estados seleccionados {finalizada, enProceso, enEdicion}
 * @param {Object} filters.fechaCreacion - Rango de fecha de creación {inicio, fin}
 * @param {Object} filters.fechaInicio - Rango de fecha de inicio {inicio, fin}
 * @param {Object} filters.fechaFinalizacion - Rango de fecha de finalización {inicio, fin}
 * @param {Object} filters.fechaEntrega - Rango de fecha de entrega {inicio, fin}
 * @param {string} filters.trabajoInterno - 'si', 'no', o 'todos'
 * @param {string|null} filters.cliente - ID del cliente seleccionado
 * @param {string|null} filters.producto - ID del producto seleccionado
 * @returns {boolean} true si hay al menos un filtro activo, false en caso contrario
 */
export function hasActiveFilters(filters) {
  if (!filters) {
    return false;
  }

  // Verificar estados
  if (filters.estados) {
    const { finalizada, enProceso, enEdicion } = filters.estados;
    if (finalizada || enProceso || enEdicion) {
      return true;
    }
  }

  // Verificar rangos de fecha (ambas fechas deben estar presentes)
  const dateRanges = [
    filters.fechaCreacion,
    filters.fechaInicio,
    filters.fechaFinalizacion,
    filters.fechaEntrega
  ];

  for (const range of dateRanges) {
    if (range && range.inicio && range.fin) {
      return true;
    }
  }

  // Verificar trabajo interno
  if (filters.trabajoInterno && filters.trabajoInterno !== 'todos') {
    return true;
  }

  // Verificar cliente
  if (filters.cliente) {
    return true;
  }

  // Verificar producto
  if (filters.producto) {
    return true;
  }

  return false;
}

